<template>

<div>
    <link href="static/bootstrap.min.css" rel="stylesheet">
    <div class="login-wrap">

        <div class="row">
            <!-- <div class="col-md-6" :style="(webW?'':'text-align: center')">
                <router-link to="EntityList">
                    <img src="../assets/img/logow.png" :class="webW?'logow':'logow_phone'">
                </router-link>
            </div> -->
            <div class="col-md-6">
                <div :class=" (webW2?'ms-login':'phonedivp') " >

                    <el-card class="box-card" >
                        <div slot="header" :class=" (webW?'':'center') ">
                            <span style="color:#f40;">登录</span> /
                            <router-link to="Reg" style="color: #888888;">注册</router-link>
                        </div>
                        <div>
                            <el-form :model="dataForm" :rules="adminRules" ref="dataForm" label-width="0px" :class="(webW2?'ms-content':'ms-content_phone')">
                                <el-form-item prop="value">
                                    <el-input placeholder="请输入" v-model="dataForm.value" class="input-with-select">
                                        <el-select style="width: 90px;" v-model="dataForm.name" slot="prepend" placeholder="用户名">
                                            <el-option @click.native="selt('uname')" label="用户名" value="uname"></el-option>
                                            <el-option @click.native="selt('email')" label="邮箱" value="email"></el-option>
                                        </el-select>
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="upass">
                                    <el-input type="password" placeholder="请输入密码" v-model="dataForm.upass"
                                              @keyup.enter="submitForm()" show-password>
                                        <template #prepend>
                                            &nbsp;&nbsp;密码&nbsp;&nbsp;&nbsp;
                                        </template>
                                    </el-input>
                                </el-form-item>
                                <el-form-item prop="code">
                                    <el-input placeholder="请输入验证码" type="number" v-model="dataForm.code">
                                        <template slot="prepend">验证码</template>
                                        <template slot="append">
                                            <img v-if="codeimg!=''" @click="getImgCodeFunc" style="height: 33px;float: left;"
                                                 :src="codeimg">
                                            <span v-else @click="getImgCodeFunc" style="width: 90px;">获取验证码</span>
                                        </template>
                                    </el-input>
                                </el-form-item>
                                <div class="login-btn">
                                    <el-button type="primary" @click="submitForm()">登录</el-button>
                                </div>
                                <div>
                                    <el-checkbox v-model="checked">自动登录</el-checkbox>
                                    <router-link to="FindUpassByEmail" class="findupass">忘记密码</router-link>
                                </div>
                            </el-form>



                        </div>
                    </el-card>


                </div>

            </div>
        </div>




<!--        <Lianjie/>-->


        <!-- 添加或者编辑弹出框 -->
        <el-dialog title="扫一扫添加客服微信" :visible.sync="kfwxVisible" style="text-align: center;" :width="!webW?'90%':'50%'">
            <img  src="../assets/img/kfwx.png"  style="max-width:300px;width: 100%;">

            <template #footer>
                    <span class="dialog-footer">
                        <el-button @click="kfwxVisible = false">取 消</el-button>
                    </span>
            </template>
        </el-dialog>
    </div>

</div>

</template>

<script>
    import Lianjie from "./Lianjie.vue";

    import {login,getImgCode} from '../api/index';
    import {delCookie, getCookie, getSessionid, getWindowWidth, lianjie, setCookie} from '../api/common';


export default {
    name: "Login",
    components: {
        Lianjie
    },

    data() {


        return{


            kfwxVisible:false,

            webW:true,
            webW2:true,

            checked:false,
            codeimg:'',
            sessionid:'',

            dataForm:{
                name: "",
                value:'',
                upass: "",
                code:'',
            },

            adminRules:{
                name: [   {  required: true,  message: "请选择登录方式",  trigger: "blur",  }  ],
                value: [   {  required: true,  message: "请输入对应的用户名或者邮箱",  trigger: "blur",  }  ],
                upass: [   {  required: true,  message: "请输入密码",  trigger: "blur",  }  ],
                code: [   {  required: true,  message: "请输入验证码",  trigger: "blur",  }  ],

            },


        }
    },
    methods: {
        seekfwx(){
            this.kfwxVisible=true;
        },
        getImgCodeFunc(){
            getImgCode({sessionid:this.sessionid}).then((res) => {
                if (res.data.status == 1) {
                    this.codeimg=res.data.obj;
                } else {
                    this.codeimg='';
                    this.$message.error(res.data.msg)
                }
            })
        },
        gotoA(a){
            window.open(lianjie[a],'_blank')
        },
        submitForm() {

            this.$refs.dataForm.validate(valid => {

                //表单验证失败
                if (!valid) {
                    //提示语
                    this.$message("请按提示填写表单");
                    return false;
                } else {
                    this.dataForm.sessionid=this.sessionid;
                    this.loading = this.$loading({
                        lock: true,
                        text: "登录中...",
                        spinner: "el-icon-loading",
                        background: "rgba(0, 0, 0, 0.5)",
                    });
                    login(this.dataForm).then((res) => {
                        this.loading.close();

                        if(res.data.status==1){


                            sessionStorage.uid=res.data.obj.uid;
                            sessionStorage.token=res.data.obj.token;


                            this.$message.success( "登录成功，跳转中...");



                            this.$store.dispatch('saveFaceimg',res.data.obj.faceimg);
                            this.$store.dispatch('saveUname',res.data.obj.uname);
                            this.$store.dispatch('saveLogininfo',JSON.stringify(res.data.obj));

                            if(this.dataForm.name=='uname'){
                                localStorage.uname=this.dataForm.value;
                            }
                            if(this.dataForm.name=='email'){
                                localStorage.email=this.dataForm.value;
                            }



                            if(this.checked==true){
                                setCookie("uid",res.data.obj.uid,30);
                                setCookie("token",res.data.obj.token,30);

                                localStorage.autologin=1;
                                localStorage.uid=res.data.obj.uid;
                                localStorage.token=res.data.obj.token;
                            }else{
                                setCookie("uid",res.data.obj.uid,null);
                                setCookie("token",res.data.obj.token,null);

                                localStorage.removeItem("autologin")
                                localStorage.removeItem("uid")
                                localStorage.removeItem("token")
                            }


                            if(res.data.obj.role=='1'||res.data.obj.role=='2'||res.data.obj.role=='50'||res.data.obj.role=='100'){
                                let tol=sessionStorage.tol||getCookie("tol");
                                if(tol!=undefined){
                                    if( tol.toLowerCase().indexOf("admin")>-1&&res.data.obj.role!='100'){
                                        sessionStorage.removeItem("tol");
                                        delCookie("tol");

                                        setTimeout(()=>{
                                            this.$router.replace("/EntityList");
                                        },2000)

                                    }
                                    if( tol.toLowerCase().indexOf("login")==-1&& tol.toLowerCase().indexOf("reg")==-1){

                                        setTimeout(()=>{
                                            this.$router.replace(tol);
                                        },2000)
                                    }
                                }
                                else{
                                    setTimeout(()=>{
                                        this.$router.replace("/EntityList");
                                    },2000)
                                }
                            }else{
                                this.$router.replace("/tip");return;
                            }









                        }else{
                            this.$message.error(res.data.msg)
                        }
                    }).catch(() => {
                        this.loading.close();

                    });

                }
            })
        },
        selt(t){
            this.dataForm.name=t;
            if(t=='uname'){
                if(localStorage.uname!=undefined)   this.dataForm.value=localStorage.uname;

            }

            if(t=='email'){
                if(localStorage.email!=undefined) this.dataForm.value=localStorage.email;
            }
        }

    },mounted() {
        this.webW = getWindowWidth() >= 992 ? true : false;
        this.webW2 = getWindowWidth() >= 400 ? true : false;
        if(this.$store.state.sessionid.trim().length==0){
            this.$store.dispatch('saveSessionid',getSessionid());
        }
        this.sessionid=this.$store.state.sessionid;

        this.dataForm.name="uname";
        this.getImgCodeFunc();

        if( localStorage.autologin==1)this.checked=true;

        if(localStorage.email!=undefined){
            this.dataForm.name="email";
            this.dataForm.value=localStorage.email;
        }
         if(localStorage.uname!=undefined){
             this.dataForm.name="uname";
             this.dataForm.value=localStorage.uname;
         }

     }
};
</script>

<style scoped>


.phonedivp{width: 100%;margin-left: 0;margin-top: 20px;}

.login-wrap {
    position: relative;
    width: 100%;
    min-height: 100vh;
    background-image: url(../assets/img/zhou.png);
    background-size: 100% 100%;
    overflow-x: hidden;
}
.el-col .el-alert--error {
    height: 70px
}
.ms-login {
    margin-top: 100px;
    width: 400px;
    margin-left: calc( 50% + 400px);
    border-radius: 10px;
    background: rgba(255, 255, 255, 0.3);
    overflow: hidden;
}
.ms-content {
    padding: 30px 30px;
}
.ms-content_phone {
    padding: 0px 0px;
}
.login-btn {
    text-align: center;
}
.login-btn button {
    width: 100%;
    height: 36px;
    margin-bottom: 10px;
}


    .logow{ margin-top: 40px;;width: 150px; margin-left: 20%;}
    .logow_phone{ margin-top: 10px;;width:100px;  }
.findupass{color: #666666;float: right;font-size: 13px;}

/deep/ .el-input-group__append, .el-input-group__prepend{
    padding:0px  0px;
}
</style>
